module.exports = __webpack_public_path__ + "img/cooperation.4b10b355.png";